import { isTenantUpsellRestricted } from '@/util/upsell-tenant-restriction-util';
import store from '@/store/store';

/** Google Calendar appointment scheduling link for BI add-on upsell CTA. */
export const BI_CALENDAR_URL = 'https://calendar.app.google/mSM8EtCXoWNj8BYN8';

/**
 * Upsell surfaces (locked nav badge, blurred BI / pre-projects pages, etc.) should be hidden:
 *   - During auth hydration / after logout (no currentUser)
 *   - For the 8 tenants in the upsell-restriction list
 */
export function shouldShowUpsellSurfaces() {
  const currentUser = store.getters['auth/currentUser'];
  if (!currentUser) return false;
  return !isTenantUpsellRestricted(currentUser.tenantId);
}
